<div class="search-container" [ngClass]="{'rapidScore': contratacion}">
    <form [formGroup]="search">
        <div class="input-search-entity">
            <input formControlName="result" autocomplete="off" type="text" id="searcher" class="input-search" [placeholder]="'LOGIN.FINDBANK' | translate">
            <img src="./assets/logos/lupa.png" alt="">
        </div>
        <div [ngClass]="{'results': search.get('result').value && results.length > 0 }">
            <div class="result" [ngClass]="{'rapidScore': contratacion}" *ngFor="let entity of results" (click)="selectEntity(entity.CodeBank);">
                <a>{{entity.Name}}</a>
            </div>
        </div>
    </form>
</div>